import { render } from "./AppFigure.vue?vue&type=template&id=64bc4518"
import script from "./AppFigure.vue?vue&type=script&lang=js"
export * from "./AppFigure.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__